import * as TYPES from "2g-constants/informationTypes";

export const STAV = {
  NEPOTVRZENY: "NEPOTVRZENY",
  NEPRIJATY: "NEPRIJATY",
  POTVRZENY: "POTVRZENY",
  PRIJATY: "PRIJATY",
  ZAMITNUTY: "ZAMITNUTY",
  ZAMITNUTY_VYLUKA_ZDROJE: "ZAMITNUTY_VYLUKA_ZDROJE"
};

export const STAV_INFOTYPE = {
  [STAV.NEPOTVRZENY]: TYPES.WARNING,
  [STAV.NEPRIJATY]: TYPES.DANGER,
  [STAV.POTVRZENY]: TYPES.SUCCESS,
  [STAV.PRIJATY]: TYPES.DEFAULT,
  [STAV.ZAMITNUTY]: TYPES.DANGER,
  [STAV.ZAMITNUTY_VYLUKA_ZDROJE]: TYPES.DANGER
};
